import type { AssistantSettings } from "./types";

const STORAGE_KEY = "voltbox-assistant-settings";

export const defaultSettings: AssistantSettings = {
  apiBaseUrl: "https://api.openai.com/v1",
  apiKey: "",
  model: "gpt-4.1-mini",
  temperature: 0.2,
  systemPrompt:
    "You are VoltBox Assistant, an enterprise Office copilot. Complete the user's task concisely, preserve useful document facts, and return only content that can be inserted into the active Office file unless the user asks otherwise.",
};

export function normalizeApiBaseUrl(value: string): string {
  return value.trim().replace(/\/+$/, "");
}

export function loadSettings(): AssistantSettings {
  if (typeof window === "undefined") {
    return defaultSettings;
  }

  const raw = window.localStorage.getItem(STORAGE_KEY);
  if (!raw) {
    return defaultSettings;
  }

  try {
    const parsed = JSON.parse(raw) as Partial<AssistantSettings>;
    return {
      ...defaultSettings,
      ...parsed,
      apiBaseUrl: normalizeApiBaseUrl(parsed.apiBaseUrl ?? defaultSettings.apiBaseUrl),
      temperature:
        typeof parsed.temperature === "number"
          ? Math.min(2, Math.max(0, parsed.temperature))
          : defaultSettings.temperature,
    };
  } catch {
    return defaultSettings;
  }
}

export function saveSettings(settings: AssistantSettings): AssistantSettings {
  const normalized = {
    ...settings,
    apiBaseUrl: normalizeApiBaseUrl(settings.apiBaseUrl),
    temperature: Math.min(2, Math.max(0, settings.temperature)),
  };

  window.localStorage.setItem(STORAGE_KEY, JSON.stringify(normalized));
  return normalized;
}
